module.exports = __webpack_public_path__ + "img/case38-jpg.cd8ba480.jpg";